import { createStore, applyMiddleware } from 'redux'
import { routerMiddleware } from 'react-router-redux'
import createHistory from 'history/createBrowserHistory'
import immutableTransform from 'redux-persist-transform-immutable'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web and AsyncStorage for react-native
import thunk from 'redux-thunk'
import rootReducer, { whitelist } from '../reducers/index'
import asyncDispatch from './asyncDispatch'
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly'
export const history = createHistory()

const configureStore = (initialState) => {
    const middlewares = [routerMiddleware(history), thunk, asyncDispatch]

    return createStore(
        persistReducer(
            {
                transforms: [immutableTransform()],
                key: 'root',
                storage,
                whitelist
            },
            rootReducer
        ),
        initialState,
        composeWithDevTools(applyMiddleware(...middlewares))
    )
}

export const store = configureStore()
export const persistor = persistStore(store)



// WEBPACK FOOTER //
// ./src/stores/index.js